import _defineProperty from "/root/.jenkins/workspace/pro-fe-mobile/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/*
 * @Module: 详情骨架
 * @Author: Teacher Tang
 * @Date: 2020-11-10 15:47:17
 * @Last Modified by: Liang Huang
 * @Last Modified time: 2021-04-06 17:24:12
 */
import React from 'react';
import ContentLoader from 'react-content-loader';
import '../Page/style'; // interface IProps {
//   className?: string;
//   style?: React.CSSProperties;
// }

var rectWidth = 375 - 16 * 2;

var SkeletonDetail = function SkeletonDetail(props) {
  var className = props.className,
      style = props.style;
  return (
    /*#__PURE__*/
    React.createElement("article", {
      className: "".concat(className || '', " SkeletonPage"),
      style: _objectSpread({}, style)
    },
    /*#__PURE__*/
    React.createElement(ContentLoader, {
      height: 500,
      width: 375
    },
    /*#__PURE__*/
    React.createElement("rect", {
      x: "16",
      y: "20",
      rx: "5",
      ry: "5",
      width: rectWidth,
      height: "205"
    }),
    /*#__PURE__*/
    React.createElement("rect", {
      x: "16",
      y: "240",
      rx: "5",
      ry: "5",
      width: "40%",
      height: "20"
    }),
    /*#__PURE__*/
    React.createElement("rect", {
      x: "16",
      y: "265",
      rx: "5",
      ry: "5",
      width: "90%",
      height: "9"
    }),
    /*#__PURE__*/
    React.createElement("rect", {
      x: "16",
      y: "280",
      rx: "5",
      ry: "5",
      width: "40%",
      height: "20"
    }),
    /*#__PURE__*/
    React.createElement("rect", {
      x: "16",
      y: "305",
      rx: "5",
      ry: "5",
      width: "90%",
      height: "9"
    }),
    /*#__PURE__*/
    React.createElement("rect", {
      x: "16",
      y: "320",
      rx: "5",
      ry: "5",
      width: "40%",
      height: "20"
    }),
    /*#__PURE__*/
    React.createElement("rect", {
      x: "16",
      y: "345",
      rx: "5",
      ry: "5",
      width: "90%",
      height: "9"
    }),
    /*#__PURE__*/
    React.createElement("rect", {
      x: "16",
      y: "360",
      rx: "5",
      ry: "5",
      width: "40%",
      height: "20"
    }),
    /*#__PURE__*/
    React.createElement("rect", {
      x: "16",
      y: "385",
      rx: "5",
      ry: "5",
      width: "90%",
      height: "9"
    })))
  );
};

export default SkeletonDetail;